import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import KochaHeader from "../KochaHeader";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import { useNavigate, useParams } from "react-router-dom";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";

export default function AddVagon({ setOpen }) {
  let [data, setData] = useState(null);
  let [names, setNames] = useState(null);
  let [loading, setLoading] = useState(false);
  let messageApi = useMessage();
  let { id } = useParams();

  let navigate = useNavigate();

  const handleUpload = async (values) => {
    try {
      setLoading(true);

      let info = await axiosInstance.post("/api/vagon", {
        ...values,
      });

      console.log("info");
      if (info?.data?.success) {
        console.log(info);
        navigate(0);
        setOpen(false);
      }
    } catch (error) {
      // getNames();
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getNames = async () => {
    try {
      setLoading(true);

      let info = await axiosInstance.get("/api/add-product");

      console.log("info");
      console.log(info);

      if (info.data.success) {
        setNames(info.data.data);
      }
    } catch (error) {
      // getNames();
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getNames();
  }, []);
  return (
    <div>
      {/* <KochaHeader /> */}
      <div className="  m-auto ">
        {/* main form */}
        <Formik
          initialValues={{
            name: "",
            date: "",
            vagon: "",
            comment: "",
          }}
          validationSchema={Yup.object({
            date: Yup.string().required("Yozish shart"),
            name: Yup.string().required("Yozish shart"),
            vagon: Yup.string().required("tanlanishi shart"),
            comment: Yup.string().required("tanlanishi shart"),
          })}
          onSubmit={(values) => {
            handleUpload(values);
          }}
        >
          <Form>
            <label htmlFor="name">Dori nomi</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="name"
              as="select"
            >
              <option value="">Dorini tanlang</option>
              {names?.map((el) => {
                return <option value={el?.name}>{el?.name}</option>;
              })}
            </Field>
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="name" />
            </div>

            {/* date */}
            <label htmlFor="date">Sana</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="date"
              type="date"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="date" />
            </div>

            {/* Vagon raqami */}
            <label htmlFor="vagon">Vagon raqami</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="vagon"
              type="text"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="vagon" />
            </div>

            {/* comment */}
            <label htmlFor="comment">Izox</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="comment"
              as="textarea"
              rows="4"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="comment" />
            </div>

            <br />
            <button
              disabled={loading}
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block w-full"
            >
              {loading ? "Yuklanmoqda" : "Qo'shish"}
            </button>
          </Form>
        </Formik>
      </div>
    </div>
  );
}
